<template>
  <PinAutoRefreshBtn
    v-if="!currentTemplate && !hide_activate_controls"
    :item="item"
    :myKey="myKey" />
  <v-btn
    width="33px"
    :disabled="!!!item.value || realtime_mode || readOnlyMode"
    variant="flat"
    class="mr-3 refresh-button"
    style="height: 56px !important"
    @click="
      openSceneOptions(
        deluge.templates[item.value],
        item['scene_data'],
        myKey,
        item['port_index']
      )
    ">
    <v-icon style="height: 33px; opacity: 0.7">mdi-arrow-right-bottom</v-icon>
  </v-btn>
  <div
    :style="`opacity: ${opaqueMode ? 1 : 0.5}`"
    class="mb-2"
    style="width: 100%">
    <v-autocomplete
      :disabled="realtime_mode || readOnlyMode"
      @update:modelValue="(uid) => createOrDeleteSceneData(uid, item)"
      filled
      dense
      auto-select-first
      clearable
      :items="safeTemplates"
      style="height: 56px"
      v-model="item.value"
      item-title="display_name"
      item-value="uid"
      :label="item.label"></v-autocomplete>
  </div>

  <div
    style="display: flex"
    v-if="!realtime_mode || !readOnlyMode">
    <v-icon
      v-if="currentTemplate?.src_scene_data?.[myKey]"
      variant="flat"
      class="ml-3 refresh-button"
      style="height: 56px !important"
      @click="handleUserIntent(myKey, originLevel)"
      :style="unLockedMode ? 'opacity: 0.3' : 'opacity: 0.7'"
      :title="
        unLockedMode
          ? 'Value inherits from Template or Source'
          : 'Value locked. (Will not inherit from Template or Source)'
      "
      :icon="
        unLockedMode ? 'mdi-lock-open-variant-outline' : 'mdi-lock-outline'
      "></v-icon>

    <!-- <PinSendNowBtn
      v-if="!currentTemplate"
      :item="item"
      :myKey="myKey" /> -->
  </div>
</template>
<script setup>
import { computed, watch, ref } from 'vue';
import { deluge } from '@/stores/deluge.js';
import PinBtn from './PinBtn.vue';
import PinAutoRefreshBtn from './PinAutoRefreshBtn.vue';
import PinSendNowBtn from './PinSendNowBtn.vue';
import { isOpaque } from './utils.js';
const opaqueMode = computed(() => {
  return isOpaque(deluge, props);
});
import { inheritanceHandler } from '../../../utils/inheritanceHandler';
const props = defineProps([
  'resetFunc',
  'originLevel',
  'hideicons',
  'createOrDeleteSceneData',
  'openSceneOptions',
  'item',
  'myKey',
  'safeTemplates',
  'currentTemplate',
  'realtime_mode',
  'hide_activate_controls',
  'readOnlyMode',
]);

const emit = defineEmits(['valueChanged']);

watch(
  () => props.item.value,
  () => {
    emit('valueChanged', [props.myKey, props.item.value]);
  }
);

const unLockedMode = ref(props.item.keyInherited);

function handleUserIntent(myKey, originLevel) {
  if (props.readOnlyMode) return;
  unLockedMode.value = !unLockedMode.value;
  props.item.userIntent = unLockedMode.value === true ? 'remove' : 'keep';
  if (unLockedMode.value === true) {
    props.resetFunc(myKey, originLevel);
  }
}

const isResetDisabled = computed(() => !!props.realtime_mode);

watch(
  () => props.item.value,
  () => {
    inheritanceHandler(props.item);
  },
  // It's required to run this watcher immediately
  // else the value will change before the handler tracks the initial value
  { immediate: true }
);
</script>
<style scoped></style>
